import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function inputValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    const validFileTypes = ['.xlsx', '.xls', '.csv'];
    const isValidFileType = validFileTypes.some(type => value?.name?.endsWith(type));

    if (!isValidFileType && value) {
      return {
        importInputFile: true,
      };
    }

    return null;
  };
}
